import { PagedSearch } from '../shared/model/paged-search.model';

export class ListingCategorySearchParams extends PagedSearch {
  public constructor() {
    super();
  }
}
